import React, { memo } from "react";
import List from "@mui/material/List";
const sxStyles = ({ spacing }) => ({
    nav: {
        padding: spacing(0, 0, 0, 0.25),
        overflowY: "auto",
        overflowX: "hidden",
        // fix scrollbar issue
        // minHeight: "153px",
    },
});
const SidebarSection = ({ children }) => (React.createElement(List, { component: "div", sx: (theme) => sxStyles(theme).nav }, children));
export default memo(SidebarSection);
//# sourceMappingURL=SidebarSection.js.map